"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowButtonTextEditor_1 = require("../../../../../../shared/components/editors/CardRowButtonTextEditor");
var react_ace_1 = require("react-ace");
var TabEditorContainer_1 = require("../../../../../../shared/components/containers/TabEditorContainer");
var BrandOfferEditor = /** @class */ (function (_super) {
    __extends(BrandOfferEditor, _super);
    function BrandOfferEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.key_main = "main";
        _this.key_additional = "additional";
        return _this;
    }
    BrandOfferEditor.prototype.getPriorityAvail = function () {
        var _ret = [];
        for (var i = 1; i <= 10; i++) {
            _ret.push({
                key: i,
                value: "\u041D\u043E\u043C\u0435\u0440-" + i,
            });
        }
        return _ret;
    };
    BrandOfferEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    offer_type_code: _item.offer_type_code,
                    offer_type_title: _item.offer_type_title,
                    description: _item.description,
                    is_deprecated: _item.is_deprecated,
                    brand_id: _item.brand_id,
                    brand_title: _item.brand_title,
                    cms_image_url: _item.cms_image_url,
                    formula_partner_profit: _item.formula_partner_profit,
                    formula_brand_profit: _item.formula_brand_profit,
                    formula_deposit_comission: _item.formula_deposit_comission,
                    formula_withdraw_comission: _item.formula_withdraw_comission,
                    order_number_key: _item.order_number,
                    order_number_val: "\u041D\u043E\u043C\u0435\u0440-" + _item.order_number,
                    order_number_avail: this.getPriorityAvail(),
                    is_all_country: _item.is_all_country,
                    test_json: _item.test_json,
                    formula_result_partner: "",
                    formula_result_brand: "",
                    formula_result_deposit: "",
                    formula_result_withdraw: "",
                    tabKey: this.key_main,
                    is_for_brand_stat: _item.is_for_brand_stat
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование оффера"]);
                });
            }
        }
        else {
            this.setState({
                title: "",
                offer_type_code: 0,
                offer_type_title: "",
                description: "",
                is_deprecated: false,
                brand_id: 0,
                brand_title: "",
                cms_image_url: "",
                formula_partner_profit: "",
                formula_brand_profit: "",
                formula_deposit_comission: "",
                formula_withdraw_comission: "",
                order_number_key: 1,
                order_number_val: "\u041D\u043E\u043C\u0435\u0440-" + 1,
                order_number_avail: this.getPriorityAvail(),
                is_all_country: false,
                test_json: "",
                formula_result_partner: "",
                formula_result_brand: "",
                formula_result_deposit: "",
                formula_result_withdraw: "",
                tabKey: this.key_main,
                is_for_brand_stat: false
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание оффера"]);
                _this.props.data.GetDefaultTestData(function (def_formula_partner, def_formula_brand, def_formula_deposit, def_formula_withdraw, def_test_json) {
                    _this.setState({
                        test_json: def_test_json,
                        formula_partner_profit: def_formula_partner,
                        formula_brand_profit: def_formula_brand,
                        formula_deposit_comission: def_formula_deposit,
                        formula_withdraw_comission: def_formula_withdraw
                    });
                });
            });
        }
        this.doReSetRules();
    };
    BrandOfferEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            offer_type_rules: { isError: false },
            brand_rules: { isError: false },
            description_rules: { isError: false },
            formula_partner_profit_rules: { isError: false },
            formula_brand_profit_rules: { isError: false },
            formula_deposit_comission_rules: { isError: false },
            formula_withdraw_comission_rules: { isError: false },
            order_number_rules: { isError: false }
        });
    };
    BrandOfferEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" } });
            return false;
        }
        if ((this.state.offer_type_code <= 0) || (!this.state.offer_type_title) || (this.state.offer_type_title.length === 0)) {
            this.setState({ offer_type_rules: { isError: true, errorMessage: "Поле [тип оффера] не выбрано!" } });
            return false;
        }
        if ((this.state.brand_id <= 0) || (!this.state.brand_title) || (this.state.brand_title.length === 0)) {
            this.setState({ brand_rules: { isError: true, errorMessage: "Поле [бренд] не выбрано!" } });
            return false;
        }
        if ((!this.state.formula_partner_profit) || (this.state.formula_partner_profit.length === 0)) {
            this.setState({ formula_partner_profit_rules: { isError: true, errorMessage: "Поле [формула партнера] не заполнено!" } });
            return false;
        }
        if ((!this.state.formula_brand_profit) || (this.state.formula_brand_profit.length === 0)) {
            this.setState({ formula_brand_profit_rules: { isError: true, errorMessage: "Поле [формула бренда] не заполнено!" } });
            return false;
        }
        if ((!this.state.formula_deposit_comission) || (this.state.formula_deposit_comission.length === 0)) {
            this.setState({ formula_deposit_comission_rules: { isError: true, errorMessage: "Поле [формула комиссии за депозит] не заполнено!" } });
            return false;
        }
        if ((!this.state.formula_withdraw_comission) || (this.state.formula_withdraw_comission.length === 0)) {
            this.setState({ formula_withdraw_comission_rules: { isError: true, errorMessage: "Поле [формула комиссии за снятие] не заполнено!" } });
            return false;
        }
        if ((!this.state.description) || (this.state.description.length === 0)) {
            this.setState({ description_rules: { isError: true, errorMessage: "Поле [описание] не заполнено!" } });
            return false;
        }
        if ((this.state.order_number_key <= 0) || (this.state.order_number_val.length === 0)) {
            this.setState({ order_number_rules: { isError: true, errorMessage: "Поле [Порядковый номер] не выбрано!" } });
            return false;
        }
        return true;
    };
    BrandOfferEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                title: this.state.title,
                description: this.state.description,
                is_deprecated: this.state.is_deprecated,
                cms_image_url: this.state.cms_image_url,
                formula_partner_profit: this.state.formula_partner_profit,
                formula_brand_profit: this.state.formula_brand_profit,
                order_number: this.state.order_number_key,
                is_all_country: this.state.is_all_country,
                is_for_brand_stat: this.state.is_for_brand_stat,
                formula_deposit_comission: this.state.formula_deposit_comission,
                formula_withdraw_comission: this.state.formula_withdraw_comission
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Оффер изменен!");
            });
        }
    };
    BrandOfferEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                brand_id: this.state.brand_id,
                title: this.state.title,
                offer_type_code: this.state.offer_type_code,
                description: this.state.description,
                is_deprecated: this.state.is_deprecated,
                cms_image_url: this.state.cms_image_url,
                formula_partner_profit: this.state.formula_partner_profit,
                formula_brand_profit: this.state.formula_brand_profit,
                order_number: this.state.order_number_key,
                is_all_country: this.state.is_all_country,
                is_for_brand_stat: this.state.is_for_brand_stat,
                formula_deposit_comission: this.state.formula_deposit_comission,
                formula_withdraw_comission: this.state.formula_withdraw_comission
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Оффер добавлен!");
            });
        }
    };
    BrandOfferEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BrandOfferEditor.prototype.getFormTitle = function () {
        if (this.props.record == null) {
            return "Добавить оффер";
        }
        else {
            return "Изменить оффер";
        }
    };
    BrandOfferEditor.prototype.DoShowSelectImageDialog = function () {
        var _this = this;
        this.props.dialogSelectImage.SetDialogTitle("Выбор изображения").SetOnSelect(function (brandIdentity, dirName, fileName) {
            _this.setState({ cms_image_url: brandIdentity + "/" + dirName + "/" + fileName }, function () {
                _this.props.dialogSelectImage.Close();
            });
        }).Show();
    };
    BrandOfferEditor.prototype.getMainContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип оффера:", placeholder: "Выберите тип оффера" }, value: { key: this.state.offer_type_code, value: this.state.offer_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        offer_type_code: newVal.key,
                        offer_type_title: newVal.value,
                        offer_type_rules: { isError: false }
                    });
                }, items: this.props.offerTypesAvail, disabled: false, required: true, rules: this.state.offer_type_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Бренд:", placeholder: "Выберите бренд оффера" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_id: newVal.key,
                        brand_title: newVal.value,
                        brand_rules: { isError: false }
                    });
                }, items: this.props.brandsAvail, disabled: this.props.record != null, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Формула партнера:", placeholder: "Введите формулу партнера" }, value: this.state.formula_partner_profit, onValueChanged: function (newVal) {
                    _this.setState({
                        formula_partner_profit: newVal,
                        formula_partner_profit_rules: { isError: false }
                    });
                }, required: true, rules: this.state.formula_partner_profit_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Формула бренда:", placeholder: "Введите формулу бренда" }, value: this.state.formula_brand_profit, onValueChanged: function (newVal) {
                    _this.setState({
                        formula_brand_profit: newVal,
                        formula_brand_profit_rules: { isError: false }
                    });
                }, required: true, rules: this.state.formula_brand_profit_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Формула комиссии депозита:", placeholder: "Введите формулу комиссии за депозит" }, value: this.state.formula_deposit_comission, onValueChanged: function (newVal) {
                    _this.setState({
                        formula_deposit_comission: newVal,
                        formula_deposit_comission_rules: { isError: false }
                    });
                }, required: true, rules: this.state.formula_deposit_comission_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Формула комиссии снятия:", placeholder: "Введите формулу комиссии за снятие" }, value: this.state.formula_withdraw_comission, onValueChanged: function (newVal) {
                    _this.setState({
                        formula_withdraw_comission: newVal,
                        formula_withdraw_comission_rules: { isError: false }
                    });
                }, required: true, rules: this.state.formula_withdraw_comission_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Порядковый номер:", placeholder: "Выберите порядковый номер" }, value: { key: this.state.order_number_key, value: this.state.order_number_val }, onValueChanged: function (newVal) {
                    _this.setState({
                        order_number_key: newVal.key,
                        order_number_val: newVal.value,
                        order_number_rules: { isError: false }
                    });
                }, items: this.state.order_number_avail, required: true, rules: this.state.order_number_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) {
                    _this.setState({
                        description: newVal,
                        description_rules: { isError: false }
                    });
                }, required: true, rules: this.state.description_rules }),
            React.createElement(CardRowButtonTextEditor_1.default, { texts: {
                    caption: "Изображение:",
                    placeholder: "Выберите изображение",
                    buttonHint: "Выберите изображение"
                }, readonly: true, onButtonClick: this.DoShowSelectImageDialog.bind(this), onValueChanged: function (newVal) {
                    _this.setState({
                        cms_image_url: newVal
                    });
                }, value: this.state.cms_image_url, buttonIcon: "search" }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Устарел", value: this.state.is_deprecated, onChecked: function (checked) {
                    _this.setState({
                        is_deprecated: checked
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Все страны", value: this.state.is_all_country, onChecked: function (checked) {
                    _this.setState({
                        is_all_country: checked
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Внутренний оффер (для отчетов)", value: this.state.is_for_brand_stat, onChecked: function (checked) {
                    _this.setState({
                        is_for_brand_stat: checked
                    });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    BrandOfferEditor.prototype.doValidateFormulaPartner = function () {
        var _this = this;
        if (this.isFormulaDataValidPartner()) {
            this.props.data.DoTestFormula(this.state.formula_partner_profit, this.state.test_json, function (result) {
                _this.setState({ formula_result_partner: result }, function () {
                    notificationHelper_1.default.ShowTextTopRightInfoNotify("Выполнено!");
                });
            }, function (errors) {
                notificationHelper_1.default.ShowTextTopRightErrorNotify(errors);
            });
        }
    };
    BrandOfferEditor.prototype.doValidateFormulaBrand = function () {
        var _this = this;
        if (this.isFormulaDataValidBrand()) {
            this.props.data.DoTestFormula(this.state.formula_brand_profit, this.state.test_json, function (result) {
                _this.setState({ formula_result_brand: result }, function () {
                    notificationHelper_1.default.ShowTextTopRightInfoNotify("Выполнено!");
                });
            }, function (errors) {
                notificationHelper_1.default.ShowTextTopRightErrorNotify(errors);
            });
        }
    };
    BrandOfferEditor.prototype.doValidateFormulaDeposit = function () {
        var _this = this;
        if (this.isFormulaDataValidBrand()) {
            this.props.data.DoTestFormula(this.state.formula_deposit_comission, this.state.test_json, function (result) {
                _this.setState({ formula_result_deposit: result }, function () {
                    notificationHelper_1.default.ShowTextTopRightInfoNotify("Выполнено!");
                });
            }, function (errors) {
                notificationHelper_1.default.ShowTextTopRightErrorNotify(errors);
            });
        }
    };
    BrandOfferEditor.prototype.doValidateFormulaWithdraw = function () {
        var _this = this;
        if (this.isFormulaDataValidBrand()) {
            this.props.data.DoTestFormula(this.state.formula_withdraw_comission, this.state.test_json, function (result) {
                _this.setState({ formula_result_withdraw: result }, function () {
                    notificationHelper_1.default.ShowTextTopRightInfoNotify("Выполнено!");
                });
            }, function (errors) {
                notificationHelper_1.default.ShowTextTopRightErrorNotify(errors);
            });
        }
    };
    BrandOfferEditor.prototype.onChangeJSON = function (newValue) {
        this.setState({ test_json: newValue });
    };
    BrandOfferEditor.prototype.getEditorHeight = function () {
        return "450px";
    };
    BrandOfferEditor.prototype.isFormulaDataValidPartner = function () {
        this.doReSetRules();
        if ((!this.state.formula_partner_profit) || (this.state.formula_partner_profit.length === 0)) {
            this.setState({ formula_partner_profit_rules: { isError: true, errorMessage: "Формула партнера не задана!" }, tabKey: this.key_main });
            return false;
        }
        return true;
    };
    BrandOfferEditor.prototype.isFormulaDataValidBrand = function () {
        this.doReSetRules();
        if ((!this.state.formula_brand_profit) || (this.state.formula_brand_profit.length === 0)) {
            this.setState({ formula_brand_profit_rules: { isError: true, errorMessage: "Формула бренда не задана!" }, tabKey: this.key_main });
            return false;
        }
        return true;
    };
    BrandOfferEditor.prototype.getAdditionalContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowButtonTextEditor_1.default, { texts: { caption: "Результат партнера:", placeholder: "Посчитать результат выполнения", buttonHint: "Посчитать результат выполнения" }, readonly: true, onButtonClick: this.doValidateFormulaPartner.bind(this), onValueChanged: function (newVal) {
                    _this.setState({
                        formula_result_partner: newVal
                    });
                }, value: this.state.formula_result_partner, buttonIcon: "calculator", disabled: false }),
            React.createElement(CardRowButtonTextEditor_1.default, { texts: { caption: "Результат бренда:", placeholder: "Посчитать результат выполнения", buttonHint: "Посчитать результат выполнения" }, readonly: true, onButtonClick: this.doValidateFormulaBrand.bind(this), onValueChanged: function (newVal) {
                    _this.setState({
                        formula_result_brand: newVal
                    });
                }, value: this.state.formula_result_brand, buttonIcon: "calculator", disabled: false }),
            React.createElement(CardRowButtonTextEditor_1.default, { texts: { caption: "Результат депозита:", placeholder: "Посчитать результат выполнения", buttonHint: "Посчитать результат выполнения" }, readonly: true, onButtonClick: this.doValidateFormulaDeposit.bind(this), onValueChanged: function (newVal) {
                    _this.setState({
                        formula_result_deposit: newVal
                    });
                }, value: this.state.formula_result_deposit, buttonIcon: "calculator", disabled: false }),
            React.createElement(CardRowButtonTextEditor_1.default, { texts: { caption: "Результат снятия:", placeholder: "Посчитать результат выполнения", buttonHint: "Посчитать результат выполнения" }, readonly: true, onButtonClick: this.doValidateFormulaWithdraw.bind(this), onValueChanged: function (newVal) {
                    _this.setState({
                        formula_result_withdraw: newVal
                    });
                }, value: this.state.formula_result_withdraw, buttonIcon: "calculator", disabled: false }),
            React.createElement(react_ace_1.default, { mode: "json", theme: "sqlserver", onChange: this.onChangeJSON.bind(this), name: "UNIQUE_ID_OF_RECORD_CONTENT_DIV_JSON", editorProps: { $blockScrolling: true }, width: "100%", height: this.getEditorHeight(), fontSize: 14, value: this.state.test_json, style: { borderStyle: "solid", borderWidth: "1px", borderColor: "#d9d9d9" } })));
    };
    BrandOfferEditor.prototype.getContent = function () {
        if (this.state.tabKey === this.key_main) {
            return this.getMainContent();
        }
        if (this.state.tabKey === this.key_additional) {
            return this.getAdditionalContent();
        }
        throw "invalid tabkey -> " + this.state.tabKey;
    };
    BrandOfferEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(TabEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 870, activeTabKey: this.state.tabKey, tabs: [
                { key: this.key_main, tab: "Главная" },
                { key: this.key_additional, tab: "Проверить формулу" }
            ], onTabChange: function (key) { _this.setState({ tabKey: key }); } }, this.getContent()));
    };
    return BrandOfferEditor;
}(React.Component));
exports.default = BrandOfferEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_brands_offers_list/ui/component/BrandOfferEditor.tsx
// module id = 2423
// module chunks = 0